import axios from "axios";
import { useCallback, useEffect, useState } from "react";

import { GET_ALL_SOUNDEFFECTS, REVIEW_NONVERBAL_SOUNDEFFECT } from "../../ApiEndpoints";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient";
import { nonverbalOf } from "./nonverbal.js";

// The project's Sound-Effect regions that non-verbal detection wrote, in time
// order, and a way to accept or reject one.
const useNonverbalRegions = (projectId) => {
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [busyId, setBusyId] = useState(null);

    const load = useCallback(async () => {
        if (!projectId) {
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(GET_ALL_SOUNDEFFECTS, { projectId });
            const all = response.data?.projectsArray || [];
            setRegions(
                all
                    .filter((region) => nonverbalOf(region))
                    .sort((a, b) => a.start - b.start || a.end - b.end)
            );
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [projectId]);

    useEffect(() => {
        load();
    }, [load]);

    const review = useCallback(
        async (region, decision) => {
            setBusyId(region.dbid);
            try {
                const response = await postWithFirebaseAuth(REVIEW_NONVERBAL_SOUNDEFFECT, {
                    projectId,
                    dbid: region.dbid,
                    decision,
                });
                const nonverbal = response.data?.nonverbal;
                setRegions((current) =>
                    current.map((item) => (item.dbid === region.dbid ? { ...item, nonverbal } : item))
                );
            } catch (err) {
                console.log(err);
                alert("Couldn't save your decision on this sound");
            } finally {
                setBusyId(null);
            }
        },
        [projectId]
    );

    return { regions, loading, busyId, review, reload: load };
};

export default useNonverbalRegions;
